import { SHOPIFY_STORE_DOMAIN, SHOPIFY_STOREFRONT_API_TOKEN } from '@portal/config/base';
import { StoreCode } from '../../../schema/storeCode';
import { TAGS } from '../constants';
import { getProductsQuery } from '../queries/product';
import { Product, ShopifyProductsOperation } from '../types';
import { removeEdgesAndNodes, reshapeProducts, shopifyFetch } from '../utils';

async function getProducts({
  domain,
  token,
  query,
  reverse,
  sortKey
}: {
  query?: string;
  reverse?: boolean;
  sortKey?: string;
  domain: string;
  token: string;
}): Promise<Product[]> {
  const res = await shopifyFetch<ShopifyProductsOperation>({
    query: getProductsQuery,
    tags: [TAGS.products],
    shopifyDomain: domain,
    accessToken: token,
    variables: {
      query,
      reverse,
      sortKey
    }
  });

  return reshapeProducts(removeEdgesAndNodes(res.body.data.products));
}

export const loadShopifyProducts = async (storeCode: StoreCode): Promise<Product[]> => {
  const products = await getProducts({
    domain: SHOPIFY_STORE_DOMAIN[storeCode],
    token: SHOPIFY_STOREFRONT_API_TOKEN[storeCode]
  });

  return products;
};
